import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClipboardCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.25004 4.58333H6.41671C5.93048 4.58333 5.46416 4.77649 5.12034 5.1203C4.77653 5.46412 4.58337 5.93044 4.58337 6.41667V17.4167C4.58337 17.9029 4.77653 18.3692 5.12034 18.713C5.46416 19.0568 5.93048 19.25 6.41671 19.25H15.5834C16.0696 19.25 16.5359 19.0568 16.8797 18.713C17.2236 18.3692 17.4167 17.9029 17.4167 17.4167V6.41667C17.4167 5.93044 17.2236 5.46412 16.8797 5.1203C16.5359 4.77649 16.0696 4.58333 15.5834 4.58333H13.75M8.25004 4.58333C8.25004 5.06956 8.4432 5.53588 8.78701 5.8797C9.13083 6.22351 9.59714 6.41667 10.0834 6.41667H11.9167C12.4029 6.41667 12.8693 6.22351 13.2131 5.8797C13.5569 5.53588 13.75 5.06956 13.75 4.58333M8.25004 4.58333C8.25004 4.0971 8.4432 3.63079 8.78701 3.28697C9.13083 2.94315 9.59714 2.75 10.0834 2.75H11.9167C12.4029 2.75 12.8693 2.94315 13.2131 3.28697C13.5569 3.63079 13.75 4.0971 13.75 4.58333M8.25004 12.8333L10.0834 14.6667L13.75 11",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgClipboardCheck;
